import React from 'react';

const SmallLogo = () => {
  return (
    <div className="smalllogoshadow text-center leading-tight font-sans text-purple-600 font-extrabold uppercase">
      <span className="block">Rich</span>
      <span>Pulse</span>
    </div>
  );
};

export default SmallLogo;
